import { use_slice_generation } from '@/hooks/store/use_slices';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { useMemo } from 'react';

export function HOOK_IMAGE__get_image_mask_for(field: FIELD__image_asset) {
  const { generation_current } = use_slice_generation(['generation_current']);

  /*
   *
   */
  const out = useMemo(() => get_image_mask(), [field, generation_current, field.hash_sha256_content]);

  /*
   *
   */
  function get_image_mask() {
    if (field.is_category_mask) return field;

    if (generation_current.is_stub()) return FIELD__image_asset.CREATE_STUB();

    let out = generation_current.tool.graph.field_image__get_mask_for(field);

    return out;
  }

  /*
   *
   */

  return out;
}
